export default defineAppConfig({
  platform: {
    id: 'bitbelicash',
    name: 'Bitbeli Cash',
    domain: 'https://dev-bitbelicash.develit.io',
  },
})
